import { ECheckServiceStatus, ICheckoutInfoState } from './types';

export const defaultAutoProlongInfo = {
  isChecked: true,
  isAvailable: false,
  hintText: '',
  tooltipText: '',
};

export const defaultTotalAmount = {
  price: 0,
  auctionPoints: 0,
};

export const defaultState: ICheckoutInfoState = {
  status: ECheckServiceStatus.initial,
  errorCode: null,
  isPurchaseAvailable: false,
  isInsufficientFunds: false,
  submitText: 'Разместить',
  servicesUnavailableMessage: null,
  autoProlongInfo: defaultAutoProlongInfo,
  totalAmount: defaultTotalAmount,
  details: [],
  promotionCost: 0,
  withoutMinimalBet: false,
};
